export default __webpack_public_path__ + "static/media/inactive5.7caf2a83.svg";